import { OAuthStrategy } from '@clerk/types';
import { XPAuthSignIn, YStack, Text, Card } from '@my/ui'
import { useNavigate, useAuth, useSignIn, useClerkSSO } from '@my/util';
import { useState } from 'react';
import images from '../../assets/images'

interface Props {
  //type: "sign-up" | "sign-in";
  handleOAuthWithPress: (strategy: OAuthStrategy) => void;
  handleEmailWithPress: (emailAddress, password) => void;
  status: 'idle' | 'loading' | 'success'
  socialLogos: {
    apple: any;
    google: any;
    microsoft: any;
  }
}

export const AuthSignIn: React.FC = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<'idle' | 'loading' | 'success'>('idle')

  const { signIn } = useSignIn();
  const appleSSO = useClerkSSO('oauth_apple');
  const googleSSO = useClerkSSO('oauth_google');
  const microsoftSSO = useClerkSSO('oauth_microsoft');
  const { userId, isLoaded } = useAuth();


  if (userId) {
    //push("/");
    //return null;
  }

  if (!isLoaded) return null;

  const redirectIfSignedIn = async () => {
    if (signIn.status === 'complete') {

      setStatus('success');
      await signIn.finalize({
        navigate: ({ session, decorateUrl }) => {
          // Handle session tasks
          // See https://clerk.com/docs/guides/development/custom-flows/authentication/session-tasks
          if (session?.currentTask) {
            return
          }

          // If no session tasks, navigate the signed-in user to the home page
          const url = decorateUrl('/')
          if (url.startsWith('http')) {
            window.location.href = url
          } else {
            navigate(url)
          }
        },
      })
    } else if (signIn.status === 'needs_second_factor') {
      // See https://clerk.com/docs/guides/development/custom-flows/authentication/multi-factor-authentication
    } else if (signIn.status === 'needs_client_trust') {
      // For other second factor strategies,
      // see https://clerk.com/docs/guides/development/custom-flows/authentication/client-trust
      const emailCodeFactor = signIn.supportedSecondFactors.find(
        (factor) => factor.strategy === 'email_code',
      )

      if (emailCodeFactor) {
        await signIn.mfa.sendEmailCode()
      }
    } else {
      // Check why the sign-in is not complete
      console.error('Sign-in attempt not complete:', signIn)
    }
  };

  const handleOAuthSignInWithPress = async (strategy: OAuthStrategy) => {
    switch (strategy) {
      case 'oauth_apple':
        await appleSSO.signIn();
        break;
      case 'oauth_google':
        await googleSSO.signIn();
        break;
      case 'oauth_microsoft':
        await microsoftSSO.signIn();
    }
    await redirectIfSignedIn();
  };

  const handleEmailSignInWithPress = async (emailAddress, password) => {
    setStatus('loading');
    const { error } = await signIn.password({
      emailAddress,
      password,
    })
    if (error) {
      console.error(JSON.stringify(error, null, 2))
      return
    }
    await redirectIfSignedIn();
  };
  return <YStack padding={40}>
    <Card padding={10}>
      <XPAuthSignIn
        handleOAuthWithPress={handleOAuthSignInWithPress}
        handleEmailWithPress={handleEmailSignInWithPress}
        status={status}
        socialLogos={{
          apple: images.authApple,
          google: images.authGoogle,
          microsoft: images.authMicrosoft
        }}
      />
    </Card>
  </YStack>

}